export default "__VITE_ASSET__ChK36owp__"